import { pmoInstance } from "config";
import { getHeader } from "config";

export const findAll = (query = {}) =>
  pmoInstance.get(`/product?${new URLSearchParams(query)}`, getHeader());
